import React from 'react'
import ContactForm from '../components/ContactForm'
import Jagadeeswara from "../assets/JagadeeswaaR.jpg"
import Mohan from "../assets/MDSR MOHAN.jpg"
const Contact = () => {
  return (
    <div className="main_page_container">
      <div className="page_heading">
        <h1>Contact Us</h1>

      </div>

      <div className="page_section">
        <div className="contact_people">
          <div className="row">
            <div className="col-md-3 my-3">
              <div className="people_img">
              <img src={Jagadeeswara} alt='People' />

              </div>
             

            </div>
            <div className="col-md-3 my-3">
              <h4>Prof. P.Jagadeeswara Rao</h4>
              <p>Professor, Dept of Geo-Engineering,</p>
              <p>Andhra University</p>
              <p> Email: <a href="mailto:mdsrmohan.pjr_geoin@rediffmail.com" target="_blank" rel="noreferrer">pjr_geoin@rediffmail.com</a></p>

            </div>
            <div className="col-md-3 my-3">
            <div className="people_img">
              <img src={Mohan} alt='People' />
              </div>
            </div>
            <div className="col-md-3 my-3">
              <h4>M.D.S.R. Mohan</h4>
              <p>PhD Research Scholar, Dept of Geo-Engineering,</p>
              <p>Andhra University</p>
              <p> Email: <a href="mailto:mdsrmohan.rs@andhrauniversity.edu.in" target="_blank" rel="noreferrer">rs@andhrauniversity.edu.in</a></p>

            </div>
          </div>

        </div>

      </div>
      <div className="page_section">
      <h2>Get in touch!</h2>
        <div className="row">
        <div className="col-md-6">
            <ContactForm />
          </div>
          <div className="col-md-6">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6897.761959168348!2d83.31287260638825!3d17.72861797969942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a39434499eb3e63%3A0xfef86702906c01e!2sAndhra%20University%2C%20Visakhapatnam%2C%20Andhra%20Pradesh%20530003!5e0!3m2!1sen!2sin!4v1687673069859!5m2!1sen!2sin"

              width="100%" height="400" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex={0}
              referrerPolicy="no-referrer-when-downgrade" title='Google Map'>
            </iframe>

          </div>
          
        </div>

      </div>

    </div>



  )
}

export default Contact